import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ServiceHelper } from "@core/helpers/service-helper";
import { Message } from "@core/models/message.model";
import { TPagination } from "@custom-types/sorting";
import { CrudType } from "@enums/crud-type";
import { MessageType } from "@enums/message-type";
import { environment } from "@env/environment";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MessageService {
  constructor(private http: HttpClient) {}

  getMessages$(pagination?: Partial<TPagination>): Observable<Array<Message>> {
    const params = ServiceHelper.getListQueryParams(undefined, pagination);
    return this.http
      .get<Array<Message>>(`${environment.BASE_URL}message`, { params })
      .pipe(
        map((response: Array<Message>): Array<Message> => {
          return response;
        })
      );
  }

  saveMessage$(
    message: Partial<Message>,
    image?: File,
    userId?: string,
    intermediaryId?: string,
    productId?: string,
    productVersionId?: string
  ): Observable<unknown> {
    const formData = new FormData();
    if (image) {
      formData.append("file", image);
    }
    if (message.messageType === MessageType.SpecificClient && userId) {
      formData.append("userId", userId);
    }
    if (message.messageType === MessageType.Intermediary && intermediaryId) {
      formData.append("intermediaryId", intermediaryId);
    }
    if (
      message.messageType === MessageType.Product &&
      productId &&
      (!productVersionId || Number(productVersionId) === -1)
    ) {
      formData.append("productId", productId);
    }
    if (
      message.messageType === MessageType.ProductVersion &&
      productVersionId
    ) {
      formData.append("productVersionId", productVersionId);
    }
    Object.keys(message).forEach((key) => {
      const value = (message as any)[key];
      if (value !== undefined && value !== null && value !== "") {
        formData.append(key, value);
      }
    });
    return this.http[CrudType.Post](
      `${environment.BASE_URL}message/`,
      formData
    );
  }

  getMessageAttachment$(id: string): Observable<Blob> {
    return this.http.get(`${environment.BASE_URL}message/attachment/${id}`, {
      responseType: "blob",
    });
  }
}
